module.exports = __webpack_public_path__ + "img/1571432324.a761396e.jpg";